import firebase from '@firebase/app'
import UserDashboardDB from '../../firebase/user-dashboard-db'
import '@firebase/firestore'

export default {
  /**
   * Fetch dashboard of current loggedin user
   */
  getUserDashboard: async ({ rootState, commit }) => {
    const dashboardRef = firebase
      .firestore()
      .collection('dashboard')
      .doc(rootState.authentication.user.id)
    dashboardRef.get().then(docSnapshot => {
      if (docSnapshot.exists) {
        dashboardRef.onSnapshot(doc => {
          commit('setDashboard', doc.data())
        })
      } else {
        dashboardRef
          .set({
            name: 'My new Dashboard',
            position1: 'blank',
            position2: 'blank',
            position3: 'blank',
            position4: 'blank',
            position5: 'clock',
            position6: 'blank',
            position7: 'blank',
            position8: 'blank',
            position9: 'subscribe'
          })
          // eslint-disable-next-line func-names
          .then(function() {
            commit('setDashboard', {
              name: 'My new Dashboard',
              position1: 'blank',
              position2: 'blank',
              position3: 'blank',
              position4: 'blank',
              position5: 'clock',
              position6: 'blank',
              position7: 'blank',
              position8: 'blank',
              position9: 'subscribe'
            })
            commit('setDashboardCreationPending', false)
          })
          // eslint-disable-next-line func-names
          .catch(function(error) {
            console.error('Error writing document: ', error)
          })
      }
    })
  },

  /**
   * Delete a user dashboard from its id
   */
  deleteUserDashboard: async ({ rootState, commit, getters }, dashboardId) => {
    if (getters.isDashboardDeletionPending(dashboardId)) return

    const userDashboardDb = new UserDashboardDB(
      rootState.authentication.user.id
    )

    commit('addDashboardDeletionPending', dashboardId)
    await userDashboardDb.delete(dashboardId)
    commit('removeDashboardById', dashboardId)
    commit('removeDashboardDeletionPending', dashboardId)
  },
  /**
   * UPDATE DATA FOR A WIDGET
   */
  updateWidgetData({ rootState }, payload) {
    const docRef = firebase
      .firestore()
      .collection('dashboard')
      .doc(rootState.authentication.user.id)
    docRef.update(payload)

    // eslint-disable-next-line no-unused-vars
    const setWithMerge = docRef.set(
      {
        payload
      },
      { merge: true }
    )
  },

  updateWidgetDataFromDialog({ rootState }, payload) {
    const newPayload = payload.updates
    const docRef = firebase
      .firestore()
      .collection('dashboard')
      .doc(rootState.authentication.user.id)
    docRef.update(newPayload[0], newPayload[1])
  },

  updateWidgetType({ rootState }, payload) {
    const docRef = firebase
      .firestore()
      .collection('dashboard')
      .doc(rootState.authentication.user.id)
    docRef.update(payload)
  }
}
